"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageLinkButton = exports.TabTitle = exports.BlackBar = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
const app_text_1 = __importDefault(require("../typography/app_text"));
exports.BlackBar = styled_1.default.div({
    height: 2,
    transition: 'all 0.2s',
    marginTop: 5,
}, ({ active, theme }) => ({
    background: theme.gradients.lightGradient,
    width: active ? '100%' : 0,
}));
exports.TabTitle = (0, styled_1.default)(app_text_1.default.withComponent('h2'))({
    transition: 'color 0.2s',
}, ({ active, theme }) => ({
    ':hover': {
        color: theme.colors.grey90,
    },
    color: active ? theme.colors.grey90 : theme.colors.grey60,
    fontFamily: theme.text.headingFontFamily,
}));
exports.PageLinkButton = styled_1.default.button({
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    background: 'none',
    border: 'none',
});
//# sourceMappingURL=page_link.styles.js.map